import type { OutcomeDefinition } from "@repo/app-types/entities/outcome";
import { Size } from "@repo/ui/helpers/helpers";
import { SlideoverContainer } from "@repo/ui/Slideover/slideoverContainer";
import type { FC } from "react";
import { OutcomeLabelsEditorSlideoverDialog } from "./outcomeLabelsEditorSlideoverDialog.js";

interface OutcomeLabelsEditorSlideoverContainerProps {
  outcome: OutcomeDefinition;
  isOpen: boolean;
  onClose: () => void;
  onSave: (outcome: OutcomeDefinition) => void;
}

/**
 * Stateless shell for the outcome-labels editor. Keeps the slideover mounted so
 * it animates open/close, while the dialog content (and its draft state) mounts
 * fresh on open and unmounts on close.
 */
export const OutcomeLabelsEditorSlideoverContainer: FC<
  OutcomeLabelsEditorSlideoverContainerProps
> = ({ outcome, isOpen, onClose, onSave }) => {
  return (
    <SlideoverContainer
      isOpen={isOpen}
      size={Size.SMALL}
      isDismissable
      onOpenChange={(newIsOpen) => {
        if (!newIsOpen) {
          onClose();
        }
      }}
    >
      <OutcomeLabelsEditorSlideoverDialog outcome={outcome} onSave={onSave} />
    </SlideoverContainer>
  );
};
